<template>
  <div class="bg-confirm-surface flex p-4 gap-4 items-center">
    <div>
      <i class="text-[32px] text-confirm fas fa-circle-check"></i>
    </div>
    <div>    
      <p class="text-sm text-normal-emphasis font-semibold">
        <slot></slot>
      </p>
    </div>
  </div>
</template>